export default class ModalKidEditController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	constructor($uibModalInstance, kid) {
		this.$uibModalInstance = $uibModalInstance;
		this.kid = kid.startsWith('K_NODE;') ? kid : `K_NODE;${kid}`;
	}

	submit() {
		this.$uibModalInstance.close({ kid: this.kid });
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
